import React, { useEffect, useId, useState } from 'react';

const COOKIE_CONSENT_KEY = 'wax-pepe-cookie-consent';

export const COOKIE_CONSENT_DESCRIPTION =
  'This site uses local storage only to remember cookie consent and does not use advertising, analytics, or tracking cookies.';

export const COOKIE_CONSENT_ITEMS = [
  {
    id: 'necessary',
    label: 'necessary',
    description: 'Required for basic site operation. These cannot be disabled.',
    required: true,
  },
  {
    id: 'consent',
    label: 'consent memory',
    description: 'Stores your cookie choice locally so the banner does not reappear.',
    required: false,
  },
];

export const getConsent = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const setConsent = (preferences) => {
  if (typeof window === 'undefined') return;
  const payload = {
    acceptedAt: new Date().toISOString(),
    preferences,
    version: '1',
  };
  localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(payload));
};

const CookieBanner = () => {
  const id = useId();
  const [open, setOpen] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true,
    consent: false,
  });

  useEffect(() => {
    const existing = getConsent();
    if (!existing) {
      const timer = setTimeout(() => setOpen(true), 120);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = (prefs) => {
    setConsent(prefs);
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-labelledby={`${id}-title`} aria-modal="true">
      <div className="cookie-banner-inner">
        <p className="cookie-banner-lead" id={`${id}-title`}>
          Cookies on this site
        </p>
        <p className="cookie-banner-text">{COOKIE_CONSENT_DESCRIPTION}</p>

        <div className="cookie-banner-items">
          {COOKIE_CONSENT_ITEMS.map((item) => (
            <label className="cookie-item" key={item.id}>
              <input
                type="checkbox"
                checked={preferences[item.id]}
                disabled={item.required}
                onChange={(event) =>
                  setPreferences((prev) => ({ ...prev, [item.id]: event.target.checked }))
                }
              />
              <span>
                <strong>{item.label}</strong>
                <small>{item.description}</small>
              </span>
            </label>
          ))}
        </div>

        <div className="cookie-banner-actions">
          <button type="button" className="btn btn-ghost" onClick={() => accept({ ...preferences, consent: false })}>
            Necessary only
          </button>
          <button type="button" className="btn btn-primary" onClick={() => accept(preferences)}>
            Accept selected
          </button>
        </div>

        <p className="cookie-banner-note">
          You can update preferences anytime from the privacy policy section.
        </p>
      </div>
    </div>
  );
};

export default CookieBanner;
